/**
 * ASP.NET's `BadRequest(string)` serializes the message as a bare JSON string, so a failed
 * request's response body arrives as `"Some Danish text"` (quotes included), not plain text.
 * Parse it back to the real message; fall back to null for anything that isn't a JSON string
 * (an empty body from a 5xx, or a genuine network failure with no body at all).
 */
export const parseBackendErrorMessage = (rawResponse) => {
  if (typeof rawResponse !== "string" || rawResponse.length === 0) {
    return null;
  }

  try {
    const parsed = JSON.parse(rawResponse);
    return typeof parsed === "string" ? parsed : null;
  } catch {
    return rawResponse;
  }
};

/**
 * `EXTRACT_PDF_FILE_CONTENT_LIMITED` (WebAPI ValidationErrors) is thrown when re-uploading an
 * extract that was already generated as Freemium and capped at the page limit. That isn't a
 * failure the user caused -- it's the Freemium page-limit consequence -- so it must not be
 * shown with the same "something went wrong" treatment as a genuine error. The backend doesn't
 * send an error code, only the resolved message, so match on the fixed part of that message
 * template (the page-count placeholder is the only variable part).
 */
export const isFreemiumPageLimitMessage = (message) =>
  typeof message === "string" &&
  message.includes("Freemium konto") &&
  message.includes("mere end");
